import { FC } from "react"
import { TravelersBatchImport } from "../../../module/travelers/containers/batchImport/index"

export const TravelersBatchImportPage: FC = () => <TravelersBatchImport />
